import {
  AutocompleteOfficeGroupResultFilter,
  AutocompleteTopicResultFilter,
  AutocompleteUserResultFilter,
} from '@ms/yammer-graphql';

import { Group, TypeaheadResults } from '../../state/types';

interface GetIdParams {
  readonly search: string;
  readonly type: keyof TypeaheadResults;
  readonly isFilteringResults?: boolean;
  readonly groupIds?: Group['id'][];
  readonly userResultFilter?: AutocompleteUserResultFilter;
  readonly topicResultFilter?: AutocompleteTopicResultFilter;
  readonly officeGroupResultFilter?: AutocompleteOfficeGroupResultFilter;
}

type GetId = (parameters: GetIdParams) => string;
export const getId: GetId = ({
  search,
  type,
  isFilteringResults,
  groupIds,
  userResultFilter,
  topicResultFilter,
  officeGroupResultFilter,
}) => {
  const officeGroupsFilterValue = officeGroupResultFilter ?? AutocompleteOfficeGroupResultFilter.EXCLUDE_M365_GROUPS;

  switch (type) {
    case 'groups':
      return `${type}-${search.toLowerCase()}-onlyGroupsWhereViewerCanPost:${isFilteringResults ?? 'false'}`;
    case 'users':
      return `${type}-${search.toLowerCase()}-groupIds:${groupIds}-excludeExternalUsers:${
        isFilteringResults ?? 'false'
      }-userResultFilter:${userResultFilter}`;
    case 'topics':
      return `${type}-${search.toLowerCase()}-topicResultFilter:${topicResultFilter}`;
    case 'officeGroups':
      return `${type}-${search.toLowerCase()}-officeGroupResultFilter:${officeGroupsFilterValue}`;
    default:
      return `${type}-${search.toLowerCase()}`;
  }
};
